import { useQuery } from '@tanstack/react-query';
import {
  fetchExamPyp,
  fetchExamQuiz,
  fetchExamSubjects,
  fetchExamTestSeries,
} from '../services/examCategoryService';

const subjectResources = new Set([
  'question-bank',
  'lecture',
  'short-notes',
  'rapid-fire',
  'flash-cards',
  'audio-podcast',
  'infographics',
]);

function resolveRequest(resourceType, params) {
  if (subjectResources.has(resourceType)) return fetchExamSubjects;
  if (resourceType === 'quiz') return fetchExamQuiz;
  if (resourceType === 'pyp') return fetchExamPyp;
  if (resourceType === 'test-series') return fetchExamTestSeries;
  return null;
}

function resolveItems(payload = {}) {
  const candidates = [
    payload.subjects,
    payload.subject_list,
    payload.question_bank_list,
    payload.lecture_list,
    payload.short_notes_list,
    payload.rapid_fire_list,
    payload.flash_cards_list,
    payload.audio_podcast_list,
    payload.infographics_list,
    payload.quiz_list,
    payload.pyp_list,
    payload.test_series_list,
    payload.data,
  ];
  return candidates.find(Array.isArray) || [];
}

export function useExamResourceList(resourceType, params = {}) {
  const request = resolveRequest(resourceType, params);

  return useQuery({
    queryKey: ['exam-resource-list', resourceType, params],
    queryFn: async () => {
      const payload = await request(params);
      const pagination = payload?.pagination || {};
      return {
        items: resolveItems(payload),
        pagination: {
          currentPage: Number(pagination.currentPage || params.page || 1),
          totalPages: Number(pagination.totalPages || 1),
        },
        payload,
      };
    },
    enabled: Boolean(request && Number(params.exams_id) && Number(params.category_id)),
    placeholderData: (previousData) => previousData,
    staleTime: 2 * 60 * 1000,
  });
}
